export const selectDeliveryJobs = (state) => state.delivery.jobs;
export const selectDeliveryJobDetail = (state) => state.delivery.jobDetail;
export const selectDeliveryDashboard = (state) => state.delivery.dashboard;
export const selectDeliveryRouteAreas =(state)=>state.delivery.routeAreas;
export const selectDeliveryRoutes = (state) => state.delivery.routes;
export const selectDeliveryUsers = (state) => state.delivery.users;
export const selectDeliveryLoading = (state) => state.delivery.loading;
export const selectDeliveryJobsLoading = (state) => state.delivery.jobsLoading;
export const selectDeliveryRoutesLoading = (state) =>  state.delivery.routesLoading;
export const selectDeliveryUsersLoading = (state) =>  state.delivery.usersLoading;
export const selectDeliveryError = (state) => state.delivery.error;

// =====================================================
// Delivery Execution
// =====================================================

export const selectDeliveryExecution = (state) => state.delivery.execution;
export const selectActiveDeliverySession = (state) =>  state.delivery.execution.session;
export const selectDeliveryRouteProgress = (state) =>  state.delivery.execution.progress;
// export const selectCurrentDeliveryPoint = (state) =>  state.delivery.execution.currentPoint;
export const selectCurrentDeliveryPoint = (state) => {
    return (
        state.delivery.execution.points?.find(
            point => point.is_current
        ) || null
    );
};

// export const selectDeliveryRoutePoints = (state) =>  state.delivery.execution.routePoints;
export const selectExecutionRoutePoints = (state)=>state.delivery.execution.points;
export const selectDeliveryMasterRoutePoints = (state)=>state.delivery.routePoints;
// export const selectDeliveryVisitLogs = (state) =>  state.delivery.execution.visitLogs;
export const selectDriverAreas = (state) =>  state.delivery.execution.driverLocation;
export const selectDriverLocation = (state) =>  state.delivery.execution.driverLocation;
export const selectDeliveryExecutionLoading = (state) =>  state.delivery.executionLoading;

export const selectRemainingStops = (state) => {
  const progress = state.delivery.execution.progress;
  if (!progress) return 0;
  return Math.max(
    (progress.total_points || 0) -
    (progress.completed_points || 0),
    0
  );
};

export const selectCompletionPercentage = (state) =>  state.delivery.execution.progress?.completion_percentage || 0;
export const selectIsRouteCompleted = (state) =>  state.delivery.execution.session?.status === "completed";
export const selectMyDeliveryRoute = (state) =>  state.delivery.myRoute;
export const selectMyDeliveryRouteLoading = (state) =>  state.delivery.myRouteLoading;